export default "__VITE_ASSET__Dox_qoIg__"